import { useNavigate, useSearchParams } from "react-router-dom";

export const useNavigateKeepParams = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return (to, options) => {
    if (typeof to !== "string") {
      navigate(to, options);
      return;
    }
    const [path, qs] = to.split("?");
    const merged = new URLSearchParams(searchParams.toString());
    if (qs) {
      new URLSearchParams(qs).forEach((v, k) => merged.set(k, v));
    }
    navigate(`${path}?${merged.toString()}`, options);
  };
};
